import React, { Component } from 'react';
import { Modal, Button, Nav, NavItem, Tab, PanelGroup, Panel } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { contractReviewerActions as actions } from '../../actions';
import { contractReviewerConstants } from '../../constants';
import '../../content/css/SummaryModal.css';
import LoadingListener from '../../helpers/loadingListener';
import { LoadingIcon } from '../LoadingIcon';
import ReactMarkdown from 'react-markdown';

class SummaryModal extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            show: this.props.show || false, // Initialize state from props
            activeTab: 'summary'
        };

        this.loadingListener = new LoadingListener([contractReviewerConstants.GET_DOCUMENT_SUMMARY_REQUEST]);
    }

    componentDidUpdate(prevProps) {
        // Sync the modal's visibility state with the incoming prop
        if (this.props.show !== prevProps.show) {
            this.setState({ show: this.props.show });
        }
    }

    handleClose = () => {
        this.setState({ show: false });
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    handleTabSelect = (tabKey) => {
        this.setState({ activeTab: tabKey });
    }

    renderTopics = (topics) => {
        if (!topics || Object.keys(topics).length === 0) {
            return <p className="empty-state">No specific topics were identified in the contract.</p>;
        }

        return (
            <PanelGroup accordion id="summary-topics-accordion">
                {topics.map((topic, index) => (
                    <Panel key={topic.name} eventKey={index.toString()}>
                        <Panel.Heading>
                            <Panel.Title toggle>{topic.topicName}</Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible>
                            <ReactMarkdown source={topic.explanation || 'No content.'} />
                        </Panel.Body>
                    </Panel>
                ))}
            </PanelGroup>
        );
    }

    renderGuidance = (guidance) => {
        if (!guidance || guidance.length === 0) {
            return <p className="empty-state">No actionable guidance was provided.</p>;
        }

        return (
            <ul className="actionable-guidance-list">
                {guidance.map((item, index) => (
                    <li key={index}>
                        <ReactMarkdown source={item} />
                    </li>
                ))}
            </ul>
        );
    }

    render() {
        const isLoading = this.loadingListener.isLoading(this.props.isLoading);
        const { data } = this.props;

        return (
            // Use size="lg" for a wider modal, better for this layout
            <Modal className="summary-modal" size="lg" show={this.state.show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Overview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isLoading && <div className="loading-container"><LoadingIcon /></div>}

                    {!isLoading && data &&
                        <Tab.Container id="summary-tabs" activeKey={this.state.activeTab} onSelect={this.handleTabSelect}>
                            <div>
                                <Nav bsStyle="pills">
                                    <NavItem eventKey="summary">Summary</NavItem>
                                    <NavItem eventKey="topics">Key Topics</NavItem>
                                    <NavItem eventKey="guidance">What to do next</NavItem>
                                </Nav>
                                <Tab.Content animation className="summary-tab-content">
                                    <Tab.Pane eventKey="summary">
                                        <ReactMarkdown className="summary-box" source={data.summary || 'No summary available.'} />
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="topics">
                                        <p className="tab-description">An explanation of the most important clauses found in the document. Click each topic to expand.</p>
                                        {this.renderTopics(data.topics)}
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="guidance">
                                        <p className="tab-description">A checklist of recommended actions and points to consider for review.</p>
                                        {this.renderGuidance(data.actionableGuidance)}
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </Tab.Container>
                    }

                    {!isLoading && !data &&
                        <div className="empty-state-container">
                            <p>Analysis data is not available or could not be loaded.</p>
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.handleClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

// No change to connect/redux logic needed.
export default connect(
    state => state.contractReviewer,
    dispatch => bindActionCreators(actions, dispatch)
)(SummaryModal);


// WEBPACK FOOTER //
// ./src/components/DocumentViewer/SummaryModal.js